import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Box } from '@hub/box';
import { Grid } from '@hub/grid';
import { Button } from '@hub/button';
import { useToken } from '@hub/design-system-base';
import { CoreContainer } from '@hub/core-container';
import { Stack } from '@hub/stack';
import { Text } from '@hub/text';
import { HoursMediumIcon, LocationDropPinMediumIcon } from '@hub/icon';
import RetailerUtilityBox from '../../components/retailer-utility-box-v2';
import { useSupportingColors } from '../../hooks/use-supporting-colors';
import { summariseOccurrences } from '../../helpers/occurrences';
import { Markdown } from '../markdown';
import InfoAccordion from '../../components/info-accordion';
import PageSharer, { ShareButtonType } from '../../components/page-sharer-v2';
import { CloudinaryImage, IMAGE_SIZES_HERO } from '../cloudinary-image';
import MemberExclusiveLabel from '../../components/member-exclusive-label';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const BasicFeature = _ref => {
  let {
    title,
    shortDescription,
    heroImage,
    supportingColor,
    location,
    body,
    retailerUtility,
    startAt,
    endAt,
    timeZone,
    eventDetail,
    termsAndConditions,
    memberExclusive
  } = _ref;
  return /*#__PURE__*/_jsxs(CoreContainer, {
    isMobileFullWidth: true,
    "data-id": "basic-feature_index_BasicFeature_CoreContainer",
    children: [/*#__PURE__*/_jsx(FeatureHeader, {
      title: title,
      shortDescription: shortDescription,
      heroImage: heroImage,
      location: location,
      supportingColor: supportingColor,
      startAt: startAt,
      endAt: endAt,
      timeZone: timeZone,
      memberExclusive: memberExclusive,
      "data-id": "basic-feature_index_BasicFeature_CoreContainer_FeatureHeader"
    }), /*#__PURE__*/_jsx(EventDetails, {
      eventDetail: eventDetail,
      "data-id": "basic-feature_index_BasicFeature_CoreContainer_EventDetails"
    }), /*#__PURE__*/_jsxs(Stack, {
      shouldWrapChildren: false,
      direction: ['column', 'column', 'row'],
      gap: ['spacing-lg', 'spacing-lg', 'spacing-xl'],
      sx: {
        marginTop: 'spacing-lg',
        marginBottom: 'spacing-xl',
        paddingX: ['spacing-mobile-margin', 0, 0],
        justifyContent: retailerUtility ? 'inherit' : 'center'
      },
      flexGrow: 0,
      "data-id": "basic-feature_index_BasicFeature_CoreContainer_Stack",
      children: [/*#__PURE__*/_jsxs(Box, {
        flex: "1",
        sx: {
          flexBasis: retailerUtility ? '70%' : '100%',
          maxWidth: retailerUtility ? ['100%', '100%', '70%'] : 'size-27',
          overflowX: 'hidden'
        },
        "data-id": "basic-feature_index_BasicFeature_Stack_Box",
        children: [/*#__PURE__*/_jsx(Markdown, {
          content: body,
          components: customComponents(),
          "data-id": "basic-feature_index_BasicFeature_Box_Markdown"
        }), termsAndConditions && /*#__PURE__*/_jsx(Box, {
          sx: {
            marginTop: 'spacing-md'
          },
          "data-id": "basic-feature_index_BasicFeature_Box",
          children: /*#__PURE__*/_jsx(Markdown, {
            content: termsAndConditions,
            components: customComponents(),
            "data-id": "basic-feature_index_BasicFeature_Box_Markdown"
          })
        })]
      }), retailerUtility && /*#__PURE__*/_jsx(Box, {
        flex: "1",
        sx: {
          flexBasis: '30%'
        },
        "data-id": "basic-feature_index_BasicFeature_Box",
        children: /*#__PURE__*/_jsx(RetailerUtilityBox, _objectSpread(_objectSpread({}, retailerUtility), {}, {
          "data-id": "basic-feature_index_BasicFeature_Box_RetailerUtilityBox"
        }))
      })]
    })]
  });
};
export const FeatureHeader = _ref2 => {
  let {
    title,
    shortDescription,
    heroImage,
    supportingColor,
    location,
    startAt,
    endAt,
    timeZone,
    memberExclusive
  } = _ref2;
  const squareImagePadding = useToken('space', 'spacing-md');
  const {
    supportingForegroundColor: primaryForegroundColor,
    supportingBackgroundColor: primaryBackgroundColor
  } = useSupportingColors(supportingColor);
  const {
    supportingForegroundColor: secondaryForegroundColor
  } = useSupportingColors(supportingColor, {
    lightForegroundColor: 'manatee',
    darkForegroundColor: 'quartz'
  });
  return /*#__PURE__*/_jsxs(Stack, {
    gap: ['spacing-5', 'spacing-5', 'spacing-10'],
    direction: ['column', 'column', 'row'],
    shouldWrapChildren: false,
    sx: {
      alignItems: ['left', 'left', 'top'],
      backgroundColor: primaryBackgroundColor,
      paddingX: ['spacing-mobile-margin', 'spacing-md', 'spacing-md'],
      paddingY: 'spacing-md',
      justifyContent: 'space-between'
    },
    flexGrow: 0,
    "data-id": "basic-feature_index_BasicFeature_Stack",
    children: [/*#__PURE__*/_jsx(Stack, {
      shouldWrapChildren: false,
      sx: {
        marginLeft: ['none', 'none', 'spacing-3xl']
      },
      direction: "row",
      align: "center",
      color: primaryForegroundColor,
      "data-id": "basic-feature_index_BasicFeature_Stack_Stack_11",
      children: /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex',
          flexDirection: 'column',
          gap: ['16px', '16px', '24px']
        },
        "data-id": "basic-feature_index_BasicFeature_Stack_Box",
        children: [/*#__PURE__*/_jsx(MemberExclusiveLabel, {
          sx: {
            width: '124px',
            marginBottom: 'spacing-sm',
            marginTop: 'spacing-md'
          },
          display: memberExclusive,
          option: "large",
          "data-id": "basic-feature_index_BasicFeature_Box_MemberExclusiveLabel"
        }), /*#__PURE__*/_jsx(Text, {
          isBodyText: true,
          as: 'h1',
          fontSize: ['font-h2', 'font-h2', 'font-h1'],
          tone: "strong",
          sx: {
            lineHeight: ['35px', '35px', '40px']
          },
          "data-id": "basic-feature_index_BasicFeature_Box_Text",
          children: title
        }), /*#__PURE__*/_jsxs(Stack, {
          direction: "row",
          shouldWrapChildren: false,
          sx: {
            color: secondaryForegroundColor,
            gap: ['16px', '16px', '24px']
          },
          "data-id": "basic-feature_index_BasicFeature_Box_Stack",
          children: [location && /*#__PURE__*/_jsx(IconInfo, {
            text: location,
            Icon: /*#__PURE__*/_jsx(LocationDropPinMediumIcon, {
              boxSize: "size-icon-sm",
              ariaLabel: "location drop pin icon",
              "data-id": "basic-feature_index_BasicFeature_LocationDropPinMediumIcon"
            }),
            "data-id": "basic-feature_index_BasicFeature_IconInfo"
          }), shortDescription && /*#__PURE__*/_jsx(Text, {
            isBodyText: true,
            sx: {
              color: primaryForegroundColor
            },
            "data-id": "basic-feature_index_BasicFeature_Text",
            children: shortDescription
          }), startAt && endAt && /*#__PURE__*/_jsx(IconInfo, {
            text: summariseOccurrences([{
              startAt,
              endAt
            }], timeZone),
            Icon: /*#__PURE__*/_jsx(HoursMediumIcon, {
              boxSize: "size-icon-sm",
              ariaLabel: "Hours icon",
              "data-id": "basic-feature_index_BasicFeature_HoursMediumIcon"
            }),
            "data-id": "basic-feature_index_BasicFeature_IconInfo"
          })]
        })]
      })
    }), heroImage && /*#__PURE__*/_jsx(Box, {
      sx: {
        flexBasis: '30%',
        minWidth: "calc((100% / 2.5) - (2 * ".concat(squareImagePadding, "))")
      },
      "data-id": "basic-feature_index_BasicFeature_Box",
      children: /*#__PURE__*/_jsx(CloudinaryImage, {
        ratio: "1",
        imageSetOrImage: {
          url: heroImage,
          type: 'WIDE'
        },
        sizes: IMAGE_SIZES_HERO,
        loadingMode: "eager",
        "data-id": "basic-feature_index_BasicFeature_Box_CloudinaryImage"
      })
    })]
  });
};
const EventDetails = _ref3 => {
  let {
    eventDetail
  } = _ref3;
  if (!eventDetail) {
    return null;
  }
  const {
    upcoming,
    pastOccurrences,
    callsToAction = []
  } = eventDetail;
  return /*#__PURE__*/_jsx(Stack, {
    shouldWrapChildren: false,
    sx: {
      alignItems: 'center',
      justifyContent: 'center',
      paddingX: ['spacing-mobile-margin', 0]
    },
    "data-id": "basic-feature_index_BasicFeature_Stack",
    children: /*#__PURE__*/_jsxs(Box, {
      sx: {
        width: '100%',
        maxWidth: 'size-27'
      },
      "data-id": "basic-feature_index_BasicFeature_Stack_Box",
      children: [/*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(InfoAccordion, {
          metaRows: upcoming,
          purpose: "Event details",
          "data-id": "basic-feature_index_BasicFeature_InfoAccordion"
        }), pastOccurrences && /*#__PURE__*/_jsx(InfoAccordion, {
          metaRows: pastOccurrences,
          purpose: "Past events",
          "data-id": "basic-feature_index_BasicFeature_InfoAccordion_26"
        })]
      }), /*#__PURE__*/_jsxs(Grid, {
        gap: ['spacing-md', 'spacing-md', 'spacing-lg'],
        templateColumns: ['1fr', '1fr', '1fr 1fr'],
        "data-id": "basic-feature_index_BasicFeature_Box_Grid",
        children: [callsToAction.filter(cta => cta.category).map(_ref4 => {
          let {
            address,
            category
          } = _ref4;
          return /*#__PURE__*/_jsx(Button, {
            variant: "outline",
            colorScheme: "licorice",
            onClick: () => window.open(address, '_blank'),
            "data-id": "basic-feature_index_BasicFeature_Button",
            children: category
          }, address);
        }), /*#__PURE__*/_jsx(PageSharer, {
          variant: "outline",
          colorScheme: "licorice",
          shareButtonType: ShareButtonType.EVENT,
          "data-id": "basic-feature_index_BasicFeature_Grid_PageSharer"
        })]
      })]
    })
  });
};
const IconInfo = _ref5 => {
  let {
    text,
    Icon
  } = _ref5;
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      display: 'flex',
      alignItems: 'center'
    },
    "data-id": "basic-feature_index_BasicFeature_Box",
    children: [Icon, /*#__PURE__*/_jsx(Box, {
      sx: {
        display: 'inline',
        marginLeft: 'spacing-sm'
      },
      "data-id": "basic-feature_index_BasicFeature_Box_Box_31",
      children: /*#__PURE__*/_jsx(Text, {
        "data-id": "basic-feature_index_BasicFeature_Box_Text",
        children: text
      })
    })]
  });
};
function customComponents() {
  return {
    p: _ref6 => {
      let {
        children
      } = _ref6;
      return /*#__PURE__*/_jsx(Text, {
        isBodyText: true,
        "data-id": "basic-feature_index_BasicFeature_Text_33",
        children: children
      });
    }
  };
}